import React from "react";
import StaticContentPage from "./StaticContentPage";
import { returnRefundText } from "../data/staticPagesContent";

const ReturnRefundPolicy = () => {
  return (
    <StaticContentPage
      title="Return & Refund Policies"
      seoTitle="Return & Refund Policy | Eveness"
      seoDescription="Review the Eveness return and refund policy, including eligibility, return conditions, refund timelines, and support guidance."
      canonicalPath="/policies/return-refund"
    >
      {returnRefundText}
    </StaticContentPage>
  );
};

export default ReturnRefundPolicy;